<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Histórico</h1>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" no-body>
            <div>
              <b-list-group flush v-for="item in items" :key="item.topic">
                <b-list-group-item button @click.prevent="$router.push({ name: 'historico-buscar', params: item })">{{
                  item.name
                }}</b-list-group-item>
              </b-list-group>
              <router-view></router-view>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      items: [
        { name: "Proceso", topic: "process", searcheable: false },
        { name: "Recepción", topic: "waybill", searcheable: true },
        { name: "Pallet", topic: "pallet", searcheable: true }
      ]
    };
  }
};
</script>

<style></style>
